module.exports = "https://cdn-shared.mathletics.com/teacher-modules/upf-assign/68/assets/images/0ed2b09e5c6cac7e94219630df89ebe8.svg";


//////////////////
// WEBPACK FOOTER
// ./~/@3plearning/3p-teacheradmin-assets/assets/icons/icon_pdf.svg
// module id = hlvj
// module chunks = 0